import { AxiosResponse } from 'axios';
import { GAMES_ENDPOINTS } from '../../constants/apiEndPoints';
import GamesPosStatusModel from '../../models/games/GamesPosStatusModel';
import ThrottledApi from '../api/throttledApi';

export interface GamesPosStatusServiceResponse {
  success: boolean;
  data: GamesPosStatusModel | null;
  error: any;
}

export const getStoreGamesPosStatus = async (
  storeId: string
): Promise<GamesPosStatusServiceResponse> => {
  try {
    const response = await ThrottledApi.get(
      GAMES_ENDPOINTS.GET_GAMES_POS_STATUS(storeId),
      {}
    ) as AxiosResponse;

    const responseData = response?.data;

    if (responseData?.detail) {
      return {
        success: false,
        data: null,
        error: responseData.detail,
      };
    }

    if (responseData && typeof responseData === 'object') {
      return {
        success: true,
        data: GamesPosStatusModel.fromServerData(responseData),
        error: null,
      };
    }

    return {
      success: true,
      data: GamesPosStatusModel.createEmpty(),
      error: null,
    };
  } catch (error: any) {
    const errorData = error.response?.data;
    const errorMessage = errorData?.detail || errorData || error.message || 'Failed to fetch games POS status';

    return {
      success: false,
      data: null,
      error: errorMessage,
    };
  }
};

const gamesService = {
  getStoreGamesPosStatus,
};

export default gamesService;
